const request = require('./request');
const Logger = require('./utils/logger');
const assert = require('./utils/assert');

function Verification(options) {
  this.options = options;
  this.log = Logger('[spotii.verification]');
  this.request = request.create({
    baseURL: options.baseUrl,
  });
}

Verification.prototype.verifyWithPhoneCode = function(id, code) {
  assert.check(code, { type: 'string', message: 'code is required' });
  return this.request('verifyWithPhoneCode', {
    url: this.options.endpoints.verifyWithPhoneCode.replace('{id}', id),
    method: 'POST',
    data: {
      code: code,
    },
  }).then(function(resp) {
    return resp.data;
  });
};

Verification.prototype.verifyWithEmailCode = function(code) {
  assert.check(code, { type: 'string', message: 'code is required' });

  return this.request('verifyWithEmailCode', {
    url: this.options.endpoints.verifyWithEmailCode,
    method: 'POST',
    data: {
      code: code,
    },
  }).then(function(resp) {
    return resp.data;
  });
};

module.exports = Verification;
